import { useEffect, useRef, useState } from 'react';

/**
 * Mantiene `true` al menos `minMs` para que el loader con logo sea visible
 * aunque la API responda en milisegundos.
 */
export function useVisibleLoading(loading, minMs = 500) {
  const [visible, setVisible] = useState(Boolean(loading));
  const startedAt = useRef(Date.now());

  useEffect(() => {
    if (loading) {
      startedAt.current = Date.now();
      setVisible(true);
      return undefined;
    }

    const elapsed = Date.now() - startedAt.current;
    const remaining = Math.max(0, minMs - elapsed);
    const timer = window.setTimeout(() => setVisible(false), remaining);
    return () => window.clearTimeout(timer);
  }, [loading, minMs]);

  return loading || visible;
}
